<script setup>
// ContactDetailNotFound.vue — empty state quando o contato nao existe
// (404, deletado, ou usuario sem permissao). Botao volta pra lista.
import { useI18n } from 'vue-i18n';

import Button from 'dashboard/components-next/button/Button.vue';

defineEmits(['goBack']);

const { t } = useI18n();
</script>

<template>
  <div
    class="flex flex-col items-center justify-center flex-1 h-full px-6 py-16 bg-n-background"
  >
    <div
      class="flex items-center justify-center size-16 rounded-full bg-n-alpha-2 text-n-slate-11 mb-4"
    >
      <span class="i-lucide-user-x size-8" />
    </div>
    <h2 class="text-lg font-medium text-n-slate-12 mb-1">
      {{ t('CONTACT_VIEW.NOT_FOUND.TITLE') }}
    </h2>
    <p class="text-sm text-n-slate-11 text-center max-w-sm mb-6">
      {{ t('CONTACT_VIEW.NOT_FOUND.DESCRIPTION') }}
    </p>
    <Button
      :label="t('CONTACT_VIEW.NOT_FOUND.BACK')"
      icon="i-lucide-arrow-left"
      size="sm"
      @click="$emit('goBack')"
    />
  </div>
</template>
